import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useState, useEffect } from 'react';
import { useTranslate } from 'lib/translate';
import Modal from 'containers/Modals/Modal';
import { Checkbox } from '@haldor/ui';
import { useSelector } from 'react-redux';

var InvalidGroupNotice = function InvalidGroupNotice(props) {
  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      open = _useState2[0],
      setOpen = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      discard = _useState4[0],
      setDiscard = _useState4[1];

  var sections = useSelector(function (state) {
    return state.sections.educationGroups;
  });
  var translate = useTranslate();
  useEffect(function () {
    if (localStorage.getItem('discard-invalid-groups-msg') != null && localStorage.getItem('discard-invalid-groups-msg') == 'yes') {
      return function () {
        return null;
      };
    }

    if (sections != null) {
      var invalidGroup = sections.find(function (section) {
        return section.classroomUrl == null || section.classroomUrl == '';
      });

      if (invalidGroup != null) {
        setOpen(true);
      }
    }
  }, [sections]);

  var onClose = function onClose() {
    setOpen(false);

    if (discard) {
      localStorage.setItem('discard-invalid-groups-msg', 'yes');
    }
  };

  var onCheckboxChange = function onCheckboxChange(checked) {
    setDiscard(checked);
  };

  return /*#__PURE__*/React.createElement(Modal, {
    type: "small news",
    overridePrompt: true,
    onClose: onClose,
    isOpen: open
  }, /*#__PURE__*/React.createElement("div", {
    className: "form"
  }, /*#__PURE__*/React.createElement("div", {
    className: "form-row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "title"
  }, translate('Workspace missing')), /*#__PURE__*/React.createElement("p", {
    style: {
      marginTop: '1.55rem'
    }
  }, translate('A configuration problem has occurred with one of your groups. This means that the group is missing a workspace in Sharepoint and no assignments or plans can be created.') + ' ', translate('Please wait and try again later. If the problem persists, please contact your school for support.')), /*#__PURE__*/React.createElement("div", {
    style: {
      margin: '2rem 0',
      marginBottom: '3rem'
    }
  }, /*#__PURE__*/React.createElement(Checkbox, {
    onChange: onCheckboxChange,
    value: discard,
    label: translate('Do not show this message again')
  })))));
};

export default InvalidGroupNotice;